import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IntegrationTypes } from 'models/integrations'
import { IMainState } from 'store/states'

const useIntegrations = () => {
  const { list: integrations } = useSelector(
    ({ general }: IMainState) => general.integrations
  )

  const integrationsMap = useMemo(
    () =>
      new Map(
        integrations.map((integration) => [
          integration.integrationType,
          integration,
        ])
      ),
    [integrations]
  )

  const integrationZoom = useMemo(() => {
    const integration = integrationsMap.get(IntegrationTypes.zoom)
    return integration?.integrationType === IntegrationTypes.zoom
      ? integration
      : undefined
  }, [integrationsMap])

  const integrationSence = useMemo(() => {
    const integration = integrationsMap.get(IntegrationTypes.sence)
    return integration?.integrationType === IntegrationTypes.sence
      ? integration
      : undefined
  }, [integrationsMap])

  const integrationCoursera = useMemo(() => {
    const integration = integrationsMap.get(IntegrationTypes.coursera)
    return integration?.integrationType === IntegrationTypes.coursera
      ? integration
      : undefined
  }, [integrationsMap])

  return {
    integrationZoom,
    integrationSence,
    integrationCoursera,
  }
}

export default useIntegrations
